// Main JavaScript file
(function () {
  "use strict";

  console.log("Femlit 2025 frontend is ready!");

  // Header search toggle
  var toggle = document.querySelector(".b-search__toggle");
  var panel = document.getElementById("b-search-panel");

  if (toggle && panel) {
    var wrap = toggle.closest(".b-search");

    var openSearch = function () {
      panel.hidden = false;
      wrap.classList.add("is-open");
      toggle.setAttribute("aria-expanded", "true");
      var field = panel.querySelector(".b-search-form__field");
      if (field) {
        field.focus();
      }
    };

    var closeSearch = function () {
      panel.hidden = true;
      wrap.classList.remove("is-open");
      toggle.setAttribute("aria-expanded", "false");
    };

    toggle.addEventListener("click", function (e) {
      e.preventDefault();
      if (wrap.classList.contains("is-open")) {
        closeSearch();
      } else {
        openSearch();
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && wrap.classList.contains("is-open")) {
        closeSearch();
        toggle.focus();
      }
    });

    document.addEventListener("click", function (e) {
      if (wrap.classList.contains("is-open") && !wrap.contains(e.target)) {
        closeSearch();
      }
    });
  }

  // Ochrana obrázkov (odstrašujúce opatrenia – nedá sa zabrániť úplne)
  (function protectImages() {
    // Zákaz kontextového menu na obrázkoch
    document.addEventListener("contextmenu", function (e) {
      if (e.target && e.target.tagName === "IMG") {
        e.preventDefault();
      }
    });

    // Zákaz ťahania (drag & drop ukladanie) obrázkov
    document.addEventListener("dragstart", function (e) {
      if (e.target && e.target.tagName === "IMG") {
        e.preventDefault();
      }
    });

    // Zákaz klávesových skratiek na ukladanie / kopírovanie obrázka
    document.addEventListener("keydown", function (e) {
      var key = (e.key || "").toLowerCase();
      if ((e.ctrlKey || e.metaKey) && (key === "s" || key === "u")) {
        e.preventDefault();
      }
    });
  })();
})();
